import { jsx as _jsx } from "react/jsx-runtime";
import { AllIcons } from './AllIcons';
import { SingleIcon } from './SingleIcon';
export const Scores = [1, 2, 3, 4, 5];
export const ScoreIcon = ({ score, style, size = 32, showAll, }) => {
    const props = { score, size, scoreIconStyle: style };
    if (!showAll) {
        return _jsx(SingleIcon, Object.assign({}, props, { isSelected: false }));
    }
    return (_jsx("div", { children: _jsx(AllIcons, Object.assign({}, props)) }));
};
